import React, { Component } from "react";
import injectSheet from "react-jss";
import Color from 'color'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { flexUtils, palette } from "../../../Theme/Theme";
import ScrollableAnchor from "react-scrollable-anchor";
import { configureAnchors } from "react-scrollable-anchor";
import styled, { keyframes } from "styled-components";
import play from "../../../../assets/play.png";
import * as Actions from "../../../Actions/Actions";
import { isMobile } from "react-device-detect";
import * as tempActions from '../../../Actions/TempPlaylistActions.js'

configureAnchors({ offset: -60, scrollDuration: 700 });

const FadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: ${props => props.isMobile ? '90vw' : '40vw'};
  min-height: 5vw;
  z-index: 2;
  margin-bottom: 1vw;
`;

const Title = styled.div`
  color: ${palette.white}
  transition: all 0.4s;
  color: ${palette.white};
  font-size: ${props => props.isMobile ? '1rem' : '2vw'};
  padding-top: 2vw;
  padding-bottom: 2vw;
  padding: 0.5rem;
  width: ${props => props.isMobile ? '60vw' : 'auto'};
  &:hover {
    cursor: pointer;
    color: ${palette.blue};
  }
`;
const Icon = styled.div`
  transition: all 0.4s;
  width: 2vw;
  font-size: ${props => props.isMobile ? '1rem' : '1.5vw'};
  color: white;
  &:hover {
    cursor: pointer;
    color: ${props => (props.trash ? palette.pink : props.play ? palette.teal : palette.blue)};
  }
`;
const IconContainer = styled.div`
  width: ${props => props.isMobile ? '30vw' : '10vw'};
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
`;

const Popup = styled.div`
  width: 20vw;
  min-width: 25rem;
  height: 15vh;
  min-height: 8rem;
  background-color: black;
  border-radius: 10px;
  margin-bottom: 20vh;
  border: 1px solid ${palette.white};
`;

const ConfirmContainer = styled.div`
  animation: ${FadeIn} 0.4s linear;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const ConfirmRow = styled.div.attrs({
  children: props => `Are you sure you want to delete ${props.title}?`
})`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${palette.white};
  margin: 0.5rem;
  font-size: 1.5rem;
`;

const FlexRow = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  align-items: center;
`;

const Button = styled.div.attrs({
  children: props => (props.confirm ? `Confirm` : `Cancel`)
})`
  transition: all 0.4s;
  color: ${palette.white};
  margin-top: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
  width: 7vw;
  min-width: 6rem;
  height: 4vh;
  border-radius: 10px;
  border: ${props => props.confirm ? `1px solid ${Color(palette.teal).darken(0.2)}` : `1px solid ${palette.pink}`};
  &:hover {
    cursor: pointer;
    background-color: ${props => (props.confirm ? Color(palette.teal).darken(0.2).toString() : palette.pink)};
  }
`;

class ShowView extends Component {
  state = {
    confirm: false
  };
  render() {
    // console.log(isMobile)
    // console.log(this.props.view.id)
    return (
      <Container isMobile={isMobile}>
        <Title
          isMobile={isMobile}
          onClick={()=>{
            this.props.dispatch(tempActions.SetPlaylistID(this.props.view.id))
            this.props.history.push(`/Home/playlists/${this.props.view.title}`)}
          }
        >
          {this.props.view.title}
        </Title>
        <IconContainer isMobile={isMobile}>
          <Icon
          isMobile={isMobile}
            onClick={() => {
              this.setState({ confirm: true });
            }}
            className="fas fa-trash-alt"
            trash
          />
          <Icon
            isMobile={isMobile}
            className="fas fa-edit"
            onClick={()=>{this.props.history.push(`/Home/playlists/${this.props.view.title}`)}}
          />
          <Icon isMobile={isMobile} onClick={this.chooseShow} play className="fas fa-play" />
        </IconContainer>
        {this.state.confirm ? this.confirmDelete() : null}
      </Container>
    );
  }

  confirmDelete = () => {
    console.log(this.props.view);
    return (
      <ConfirmContainer>
        <Popup>
          <ConfirmRow title={this.props.view.title} />
          <FlexRow>
            <Button
              onClick={() => {
                this.setState({ confirm: false });
              }}
            />
            <Button confirm onClick={this.deletePlaylist} />
          </FlexRow>
        </Popup>
      </ConfirmContainer>
    );
  };

  chooseShow = () => {
    // if (!this.props.loggedUserState.logged) {
    //   this.showHero(this.props.content);
    //   return;
    // }
    if (this.props.user.quality === "None") {
      this.props.history.push('/Home')
      return;
    }
    if (isMobile) {
      // console.log(this.props.content)
      this.props.content.progress = 0;
      this.props.dispatch(Actions.ChooseShow(this.props.content, this.props.rowNum, this.props.history));      
      return;
    }
    let content = this.props.library.view[this.props.rowNum].contentList[0]
    // console.log(content)
    content.progress = 0;
    content.index = 0;
    this.props.dispatch(Actions.ChooseShow(content, this.props.rowNum, this.props.history));    
  }

  deletePlaylist = () => {
    this.props.dispatch(
      Actions.deletePlaylist(this.props.view.title, this.props.user.token)
    );
    this.setState({ confirm: false });
  };
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    library: state.mainState.library
  };
};

export default withRouter(connect(mapStateToProps)(ShowView));



// WEBPACK FOOTER //
// ./src/js/Components/Home/Playlists/PlaylistRow.jsx